import {
  ActionType, FilterCriteriaType, ReduxStateType,
} from '@/types/av-check';

import {
  emptyFilterValues,
  getAvailableContractDurations,
  getAvailableTargetGroups,
  getCurrentContractDuration,
  getCurrentTargetGroup,
  getMatchedTariffOffers,
  getTariffOffers,
} from '@/utils';

import { getSessionTargetGroup, setSessionTargetGroup } from '@/utils/session';
import {
  SET_ADDRESS,
  SET_CITY_LIST,
  SET_CURRENT_CONTRACT_DURATION,
  SET_CURRENT_TARGET_GROUP,
  SET_SPECIAL_RESERVATIONS,
  SET_PAGE_VALUE,
  SET_RESULT,
  SET_RESULT_ERROR,
  SET_STREET_LIST,
  SET_HOUSEHOLD_CONFIG,
  SET_TRACKING_INFO,
} from './action-types';

export const reducer = (state = {} as ReduxStateType, action: ActionType) => {
  switch (action.type) {
    case SET_ADDRESS:
      return { ...state, address: action.value };
    case SET_HOUSEHOLD_CONFIG:
      return { ...state, householdConfig: action.value };
    case SET_PAGE_VALUE:
      return {
        ...state,
        cmsContent: action.value.cmsContent,
        meta: action.value.meta,
        enabledFeatures: action.value.enabledFeatures,
        index: action.value.index,
      };
    case SET_RESULT: {
      const tariffOffers = getTariffOffers(action.value);
      const availableTargetGroups = getAvailableTargetGroups(tariffOffers);

      const currentTargetGroup = getCurrentTargetGroup(availableTargetGroups, (getSessionTargetGroup() || state.meta?.defaultTargetGroup));

      const tariffOffersForTargetGroup = getMatchedTariffOffers(tariffOffers,
        { ...emptyFilterValues(), [FilterCriteriaType.TARGET_GROUP]: currentTargetGroup });

      const availableContractDurations = getAvailableContractDurations(tariffOffersForTargetGroup);
      const currentContractDuration = getCurrentContractDuration(availableContractDurations, action.value && action.value.currentContractDuration
      && action.value.currentContractDuration != 0 ? action.value.currentContractDuration : undefined );

      return {
        ...state,
        result: action.value,
        filterValues: {
          [FilterCriteriaType.TARGET_GROUP]: currentTargetGroup,
          [FilterCriteriaType.CONTRACT_DURATION]: currentContractDuration,
          [FilterCriteriaType.SPECIAL_RESERVATION]: false,
        },
      };
    }
    case SET_RESULT_ERROR: return { ...state, resultError: action.value };
    case SET_CURRENT_TARGET_GROUP: {
      const tariffOffers = getTariffOffers(state.result);

      const availableTargetGroups = getAvailableTargetGroups(tariffOffers);

      const currentTargetGroup = getCurrentTargetGroup(availableTargetGroups, action.value);
      setSessionTargetGroup(currentTargetGroup);

      const tariffOffersForTargetGroup = getMatchedTariffOffers(tariffOffers,
        { ...emptyFilterValues(), [FilterCriteriaType.TARGET_GROUP]: currentTargetGroup });

      const availableContractDurations = getAvailableContractDurations(tariffOffersForTargetGroup);
      const currentContractDuration = getCurrentContractDuration(availableContractDurations);
      return {
        ...state,
        filterValues: {
          [FilterCriteriaType.TARGET_GROUP]: currentTargetGroup,
          [FilterCriteriaType.CONTRACT_DURATION]: currentContractDuration,
          [FilterCriteriaType.SPECIAL_RESERVATION]: false,
        },
      };
    }
    case SET_CURRENT_CONTRACT_DURATION: {
      const tariffOffers = getTariffOffers(state.result);

      const filteredTariffOffers = getMatchedTariffOffers(tariffOffers,
        {
          ...state.filterValues,
          [FilterCriteriaType.CONTRACT_DURATION]: undefined,
        });

      const availableContractDurations = getAvailableContractDurations(filteredTariffOffers);
      const currentContractDuration = getCurrentContractDuration(availableContractDurations, action.value);
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          [FilterCriteriaType.CONTRACT_DURATION]: currentContractDuration,
        },
      };
    }
    case SET_CITY_LIST:
      return { ...state, cityList: action.value };
    case SET_STREET_LIST:
      return { ...state, streetList: action.value };
    case SET_SPECIAL_RESERVATIONS: {
      const tariffOffers = getTariffOffers(state.result);

      const filteredTariffOffers = getMatchedTariffOffers(tariffOffers,
        { ...state.filterValues, [FilterCriteriaType.SPECIAL_RESERVATION]: action.value });

      console.log('This is filteredTariffOffers ', filteredTariffOffers);

      const availableContractDurations = getAvailableContractDurations(filteredTariffOffers);
      const currentContractDuration = getCurrentContractDuration(availableContractDurations);
      console.log('This is currentContractDuration ', currentContractDuration);

      return {
        ...state,
        filterValues: {
          [FilterCriteriaType.CONTRACT_DURATION]: currentContractDuration,
          [FilterCriteriaType.TARGET_GROUP]: state.filterValues.TARGET_GROUP,
          [FilterCriteriaType.SPECIAL_RESERVATION]: action.value,
        },
      };
    }
    case SET_TRACKING_INFO:
      return { ...state, trackingInfo: action.value };
    default:
      return state;
  }
};

export default reducer;
